import { defineStore } from "pinia";
import api from "@/modules/api";
import { MateTone, MateToneCategory } from "@/types/entity";
import i18n from "@/locales";

export const useTone = defineStore("tone", {
  state: () => {
    return {
      list: [] as MateTone[],
      toneMap: {} as Record<number, MateTone>,
      bgmList: [] as MateTone[],
      toneCategoryList: [] as MateToneCategory[],
    };
  },
  getters: {
    languageSet(state): Set<number> {
      return new Set(state.list.map((tone) => tone.languageId));
    },
    modalId2Name(state): Map<number, string> {
      const map = new Map();
      state.list.forEach((tone) => {
        map.set(tone.id, tone.modelName);
      });
      return map;
    },
  },
  actions: {
    /**
     * 获取Mate列表
     * 1. 如果已经请求过，直接返回
     * 2. 如果没有请求过，请求并返回
     */
    async getToneList(): Promise<MateTone[]> {
      if (this.list && this.list.length > 0) {
        return this.list;
      } else {
        const res = await api.readMateTone();
        this.list = res.page.data.filter((tone) => tone.media);
        this.list.forEach((tone) => {
          this.toneMap[tone.id] = tone;
        });
        return this.list;
      }
    },

    async getToneCategoryList(): Promise<MateToneCategory[]> {
      if (this.toneCategoryList && this.toneCategoryList.length > 0) {
        return this.toneCategoryList;
      } else {
        const res = await api.readMateToneCategoryPage();
        const list = res.page.data;
        // 角色扮演提前
        list.sort((a) => (a.id === 4 ? -1 : 1));
        this.toneCategoryList = list;
        return this.toneCategoryList;
      }
    },

    async getBgmList(): Promise<MateTone[]> {
      if (this.bgmList && this.bgmList.length > 0) {
        return this.bgmList;
      } else {
        const [toneRes, mediaRes] = await Promise.all([
          api.readBgmTone(),
          api.readMateMediaPage({
            filter: {
              type: 3,
            },
            pagination: {
              page: 1,
              perPage: 999,
            },
          }),
        ]);
        this.bgmList = [
          {
            id: null,
            mediaId: null,
            name: i18n.global.t("game.noBackgroundMusic"),
          },
          ...toneRes.page.data.filter((tone) => tone.media),
          ...mediaRes.page.data.map((media) => ({
            id: media.id,
            mediaId: media.mediaId,
            media: media.media,
            name: media.name || i18n.global.t("Message.untitledMusic"),
            toneMood: 9,
          })),
        ];
        return this.bgmList;
      }
    },
    getToneById(id: number): MateTone | undefined {
      return this.list.find((tone) => tone.id === id);
    },
    getBgmByMediaId(id: number): MateTone | undefined {
      return this.bgmList.find((tone) => tone.mediaId === id);
    },
    getBgmById(id: number): MateTone | undefined {
      return this.bgmList.find((tone) => tone.id === id);
    },
  },
});
